import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import type { Schema } from "@bw/shared/types/generated";
import { visuallyHidden } from "../../../common/visuallyHidden";

import {
  TournamentPublicLiveBoard,
  type TournamentPublicScheduleState,
} from "./TournamentLiveTab";

type Snapshot = Schema["TournamentPublicLiveSnapshot"];

export function TournamentPublicLiveTab({
  snapshot,
  loading,
  error,
  onRetry,
  schedule,
}: {
  snapshot: Snapshot | null;
  loading: boolean;
  error: boolean;
  onRetry?: () => Promise<unknown> | void;
  schedule?: TournamentPublicScheduleState;
}) {
  if (error) {
    return (
      <Stack component="section" aria-label="Tournament live">
        <Alert
          severity="error"
          action={
            onRetry ? (
              <Button size="small" onClick={() => void onRetry()}>
                Retry
              </Button>
            ) : undefined
          }
        >
          Schedule and results are temporarily unavailable.
        </Alert>
      </Stack>
    );
  }
  if (loading || !snapshot) {
    return (
      <Stack component="section" aria-label="Tournament live">
        <Typography role="status">Loading schedule and results…</Typography>
      </Stack>
    );
  }

  return (
    <Stack component="section" aria-label="Tournament live" spacing={2}>
      <Typography component="h2" sx={visuallyHidden}>
        Schedule
      </Typography>
      {snapshot.schedule_plan_revision !== null ? (
        <Typography color="text.secondary" variant="body2">
          Plan revision {snapshot.schedule_plan_revision}
        </Typography>
      ) : null}
      <TournamentPublicLiveBoard
        courts={snapshot.courts}
        initialMatches={snapshot.matches}
        schedule={schedule}
      />
    </Stack>
  );
}
